import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 408FA22D-2054-4579-A991-DF061CDE5A00
 * name perspective-less
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/perspective-less.svg
 * tags
 * - Math 
 */
export const PerspectiveLessIcon = createSvgIcon(<><path d="M16.56,12L19.23,20H4.78L7.44,12H16.56M7,1L3,5L7,9V6H11V4H7V1M17,1V4H13V6H17V9L21,5L17,1M18,10H6L2,22H22L18,10Z" /></>, 'PerspectiveLessIcon');
export default PerspectiveLessIcon